import * as d3 from 'd3';
import textCoordinates from '../config/text-coordinates.js';
import interconnectorsPathCoordinates from '../config/interconnectors-coordinates.js';

const chartCache = {};
function getChart(dataset) {
  // Return existing or create new

}
const tooltip = d3.select("body").append("div")
  .attr("class", "country-tooltip")
  .style("opacity", 0)
  .style("position", "absolute")
  .style("background", "white")
  .style("padding", "5px 10px")
  .style("border", "1px solid #ccc")
  .style("border-radius", "3px")
  .style("pointer-events", "none");





function drawInterconnectorChart(data, position, country) {
  // console.log("Drawing interconnector chart for country:", country, "with data:", data);
  if (chartCache[country]) return chartCache[country].style("left", `${position.x}px`)
    .style("top", `${position.y}px`)
    .style("opacity", 0.8);;
  chartCache[country] = d3.select("body").append("div")
    .attr("class", "interconnector-chart")
    .style("position", "absolute")
    .style("background", "white")
    .style("padding", "15px")
    .style("border", "1px solid #ccc")
    .style("border-radius", "5px")
    .style("box-shadow", "0 2px 10px rgba(0,0,0,0.1)")
    .style("opacity", 0)
    .style("pointer-events", "none")
    .style("width", "400px")
    .style("height", "300px");
  // Clear previous chart
  const chartContainer = chartCache[country];
  chartContainer.html("");

  // Create SVG
  const svg = chartContainer.append("svg")
    .attr("width", "100%")
    .attr("height", "100%");

  // Set up dimensions
  const margin = { top: 20, right: 30, bottom: 30, left: 40 };
  const width = 400 - margin.left - margin.right;
  const height = 300 - margin.top - margin.bottom;
  const chart = svg.append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);

  // Parse dates
  const parseTime = d3.timeParse("%Y-%m-%dT%H:%M:%S.%LZ");
  let title = ""
  // Determine interconnectors based on country
  // const interconnectors = country === 'GB'
  //   ? ['intelec', 'intfr', 'intifa2', 'intned', 'intnem', 'intnsl', 'intvkl']
  //   : ['intirl', 'intew', 'intmol'];
  let interconnectors = []
  if (country === 'GB') {
    interconnectors = ['intfr', 'intifa2', 'intned', 'intnem', 'intnsl', 'intvkl'];
    title = "Great Britain Interconnectors";
  } else if (country === 'IE') {
    interconnectors = ['intirl', 'intew', 'intmol'];
    title = "Ireland Interconnectors";
  } else if (country === 'TextBoxGB') {
    interconnectors = ['britishDemand', 'britishSolar', 'britishWind']
    title = "Great Britain Demand, Solar and Wind";
  } else if (country === 'TextBoxIE') {
    interconnectors = ['IrishDemand', 'IrishWind']
    title = "Ireland Demand and Wind";
  } else if (country === 'TextBoxSW') {
    interconnectors = ['britishFrequency', 'IrishFrequency', 'europeanFrequency']
    title = "Frequency";
  }
  // Calculate Y domain
  const yMax = d3.max(data, d =>
    d3.max(interconnectors.map(ic => (d[ic]))))
  //const yMin = -yMax * 0.1; // Add 10% padding below zero
  const yMin = d3.min(data, d =>
    d3.min(interconnectors.map(ic => (d[ic]))))
  // Set up scales
  const x = d3.scaleTime()
    .range([0, width])
    .domain(d3.extent(data, d => parseTime(d.dateTime)));

  const y = d3.scaleLinear()
    .range([height, 0])
    .domain([yMin, yMax]); // Add 10% padding above


  // Add axes
  chart.append("g")
    .attr("transform", `translate(0,${height})`)
    .call(d3.axisBottom(x).ticks(5));

  chart.append("g")
    .call(d3.axisLeft(y));

  // Add axis labels
  chart.append("text")
    .attr("transform", `translate(${width / 2}, ${height + margin.bottom - 5})`)
    .style("text-anchor", "middle")
    .style("font-size", "10px")
    .text("Time");

  chart.append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", -margin.left)
    .attr("x", -height / 2)
    .style("text-anchor", "middle")
    .text("MW");

  // Create line generator
  const line = d3.line()
    .x(d => x(parseTime(d.dateTime)))
    .y(d => y(d.value));

  // Define color scale
  const color = d3.scaleOrdinal()
    .domain(interconnectors)
    .range(d3.schemeCategory10);

  // Draw each interconnector line
  interconnectors.forEach(ic => {
    const lineData = data.map(d => ({
      dateTime: d.dateTime,
      value: d[ic]
    }));

    chart.append("path")
      .datum(lineData)
      .attr("fill", "none")
      .attr("stroke", color(ic))
      .attr("stroke-width", 1.5)
      .attr("d", line);

    // Add legend
    chart.append("circle")
      .attr("cx", width - 100)
      .attr("cy", interconnectors.indexOf(ic) * 20 + 10)
      .attr("r", 5)
      .attr("fill", color(ic));

    chart.append("text")
      .attr("x", width - 90)
      .attr("y", interconnectors.indexOf(ic) * 20 + 13)
      .text(ic.replace('int', '').toUpperCase())
      .style("font-size", "12px");
  });

  // Add chart title
  chart.append("text")
    .attr("x", width / 2)
    .attr("y", -5)
    .attr("text-anchor", "middle")
    .style("font-size", "20px")
    .style("font-weight", "bold")
    .text(`${title}`);

  // Position the chart
  chartContainer
    .style("left", `${position.x}px`)
    .style("top", `${position.y}px`)
    .style("opacity", 0.8);

  //chartCache[country] = chartContainer


}



const drawMap = (props, data) => {
  //console.log(Object.keys(textCoordinates))
  //drawSquare({ x: 16, y: 302, height: 50, width: 65, color: '#ffffe5', classNameBox: 'TextBox TextBoxIE' });
  const svg = d3.select(".new-d3-components").selectAll("*").remove();
  colorMap();

  if (props) {
    console.log(props, data);
    drawSquare({ x: 8, y: 302, height: 50, width: 76, color: '#ffffe5', classNameBox: 'TextBox TextBoxIE' });
    drawSquare({ x: 62, y: 197, height: 36, width: 65, color: '#f7fcb9', classNameBox: 'TextBox TextBoxGB' });
    drawSquare({ x: 243, y: 348, height: 10, width: 60, color: '#ffffff', classNameBox: 'TextBox TextBoxSW' });
    drawTextandValues(props)
    drawInterconnector(props)

  }
  let country = '';
  let datachosen = '';
  /////////////////////////////////////////////////////////////////
  d3.selectAll(".TextBox")
    .on("mouseover", function (event) {



      if (this.classList.contains("TextBoxGB")) {
        country = "TextBoxGB";
        datachosen = data.GBAll; // Your GB data
      } else if (this.classList.contains("TextBoxIE")) {
        country = "TextBoxIE";
        datachosen = data.IrishAll; // Your IE data
      } else if (this.classList.contains("TextBoxSW")) {
        country = "TextBoxSW";
        datachosen = data.freqAll; // Your IE data
      }
      //console.log("Mouseover event triggered", this.classList, this.classList.contains("TextBox"), country, datachosen);
      if (country && datachosen) {
        const [x, y] = d3.mouse(d3.select("body").node());
        //console.log("cache:", chartCache)
        const chart = getChart(country);
        drawInterconnectorChart(datachosen, { x: x + 15, y: y + 15 }, country);
      }
    })
    .on("mouseout", function () {
      chartCache[country].transition().duration(300).style("opacity", 0);
    })
    .style("cursor", "pointer");



  d3.selectAll(".label")
    .on("mouseover", function (event) {

      // let country = '';
      //let datachosen = '';

      if (this.classList.contains("britishDemand") || this.classList.contains("britishWind") || this.classList.contains("britishSolar")) {
        country = "TextBoxGB";
        datachosen = data.GBAll; // Your GB data
      } else if (this.classList.contains("irishDemand") || this.classList.contains("irishWind")) {
        country = "TextBoxIE";
        datachosen = data.IrishAll; // Your IE data
      } else if (this.classList.contains("britishFrequency") || this.classList.contains("europeanFrequency") || this.classList.contains("IrishFrequency")) {
        country = "TextBoxSW";
        datachosen = data.freqAll; // Your IE data
      }
      //console.log("Mouseover event triggered", this.classList, this.classList.contains("TextBox"), country, datachosen);
      if (country && datachosen) {
        const [x, y] = d3.mouse(d3.select("body").node());
        drawInterconnectorChart(datachosen, { x: x + 15, y: y + 15 }, country);
      }

    })
    .on("mouseout", function () {
      chartCache[country].transition().duration(300).style("opacity", 0);
    })
    .style("cursor", "pointer");

  d3.selectAll("#GB, #IE")
    .on("mouseover", function (event) {
      const [x, y] = d3.mouse(d3.select("body").node());
      datachosen = this.id === "GB" ? data.interconnectorsAll : data.IEinterconnectorsAll;
      country = this.id;
      drawInterconnectorChart(datachosen, { x: x + 10, y: y + 10 }, country);
    })
    .on("mouseout", () => {
      //console.log(country);
      chartCache[country].transition().duration(500).style("opacity", 0);
    })

  // const svg = d3.select("svg");
  // const svg = d3.select(".new-d3-components");
  const g = svg.append("g");
  const zoom = d3.zoom()
    .scaleExtent([0.5, 5]) // Set min and max zoom scale
    .on("zoom", (event) => {
      g.attr("transform", event.transform);
    });
  svg.call(zoom);
  d3.scaleLinear(zoom)
  svg.on("wheel", (event) => {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  }, { passive: false });
}

function drawTextandValues(props) {
  for (let key of Object.keys(textCoordinates)) {
    if (props[key]) {
      var text = textCoordinates[key].text + ': ' + props[key].value + textCoordinates[key].unit;
      drawText(
        textCoordinates[key].textCoordinates,
        text,
        ['demand', key]
      );
    }
  }
}

function drawInterconnector(props) {
  for (let key of Object.keys(interconnectorsPathCoordinates)) {
    if (typeof props.interconnectors[key] !== 'undefined') {
      if (!(key === 'intew' || key === 'intmol' || key === 'intirl')) {
        var className = interconnectorClassName(props.interconnectors[key])
        drawLine(interconnectorsPathCoordinates[key].lineCoordinates, className, "", props.interconnectors[key]);
        drawText(
          interconnectorsPathCoordinates[key].textCoordinates,
          Math.abs(props.interconnectors[key]) + ' MW'
        );
      }
      if (key === 'intew' || key === 'intmol' || key === 'intirl') {
        var className = 'irishInter ' + interconnectorClassName(-1 * props.irishInterconnectors[key])
        drawLine(interconnectorsPathCoordinates[key].lineCoordinates, className, 'irishInterLine', props.irishInterconnectors[key]);
        drawText(
          interconnectorsPathCoordinates[key].textCoordinates,
          Math.abs(props.irishInterconnectors[key]) + ' MW',
          ['interconnector', key]
        );
      }
    }
  }
}

function interconnectorClassName(interconnectorValue) {
  if (interconnectorValue < 0) {
    return 'reverse';
  } else if (interconnectorValue === 0) {
    return 'zero';
  }
  return '';
}

function colorMap() {
  var color_scale = d3.scaleOrdinal()
    .range(d3.schemeSet2);
  var color_scale2 = d3.scaleOrdinal()
    .range(d3.schemeGreys[9]);
  d3.selectAll('.land-inner')
    .attr('fill', function (d) {
      return color_scale(Math.random());
    });
  d3.selectAll('.outside')
    .attr('fill', function (d) {
      return color_scale2(Math.random());
    });
  d3.selectAll('#IE')
    .attr('fill', '#ffffe5')
  d3.selectAll('#GB')
    .attr('fill', '#f7fcb9')
}

function drawText(coordinates, text, className) {
  var classNameJoined = (className) ? className.join(' ') : ''
  d3.select(".new-d3-components").append("text")
    .attr("x", coordinates.x)
    .attr("y", coordinates.y)
    .attr("class", "label " + classNameJoined)
    .text(`${text}`);
}

function drawSquare(attr) {
  d3.select(".new-d3-components")
    .append('rect')
    .attr("x", attr.x)
    .attr("y", attr.y)
    .attr("height", attr.height)
    .attr("width", attr.width)
    .attr("fill", attr.color)
    .attr("class", attr.classNameBox)
    .style("opacity", .8)
}

function drawLine(coordinates, className = '', lineClass = '', rate = 2) {
  var lineGenerator = d3.line()
    .x(function (d) {
      return d[0];
    })
    .y(function (d) {
      return d[1];
    })
    .curve(d3.curveBasis);

  var line = lineGenerator(coordinates)
  d3.select(".new-d3-components")
    .append("path")
    .attr("class", "backG " + lineClass)
    .attr('d', line);

  d3.select(".new-d3-components")
    .append("path")
    .attr("class", "line " + className)
    .attr('d', line)
    .style("animation-duration", `${200 - (Math.abs(rate) / 1500) * 140 + (5 / Math.abs(rate)) * 100}s`)
}



export const initMapZoom = ({ svgContent, container, onScaleChange }) => {
  const zoomFactor = 0.1;
  const maxScale = 5;
  const minScale = 0.55;
  let currentScale = 1;
  let offsetX = 0; // Translation in X
  let offsetY = 0; // Translation in Y

  const handleWheel = (e) => {
    if (!e.ctrlKey) return; // Only zoom when Ctrl is held
    e.preventDefault();

    const rect = container.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    // Calculate zoom direction (inverted for natural scrolling)
    const delta = e.deltaY > 0 ? -zoomFactor : zoomFactor;

    // Calculate and clamp new scale
    const newScale = Math.min(Math.max(currentScale + delta, minScale), maxScale);

    if (newScale !== currentScale) {
      // Adjust offsets to ensure SVG remains fully visible
      const scaleRatio = newScale / currentScale;

      // Update offsets to prevent losing top-left part of SVG
      offsetX = mouseX - (mouseX - offsetX) * scaleRatio;
      offsetY = mouseY - (mouseY - offsetY) * scaleRatio;

      // Ensure the top-left corner does not move out of bounds
      offsetX = Math.max(offsetX, 0);
      offsetY = Math.max(offsetY, 0);

      currentScale = newScale;

      // Apply transformations to keep everything in view
      svgContent.style.transformOrigin = "0 0"; // Ensures scaling happens from the top-left corner
      svgContent.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${currentScale})`;

      // Notify parent component of scale change
      onScaleChange(newScale);
    }
  };

  container.addEventListener('wheel', handleWheel, { passive: false });

  return () => {
    container.removeEventListener('wheel', handleWheel);
  };
};
//mouse hover country name:



// Add hover events to SVG sections
// d3.selectAll(".land-inner, .other-selector")
//   .on("mouseover", function (event, d) {
//     const sectionId = this.id; // Get SVG element's ID
//     console.log(sectionId);
//     const [x, y] = d3.mouse(event, this); // Get hover position

//     tooltip.transition()
//       .duration(200)
//       .style("opacity", 1)
//       .style("left", `${ event.pageX + 10 }px`)
//       .style("top", `${ event.pageY + 10 }px`)
//       .text(getTooltipText(sectionId)); // Custom text based on ID
//   })
//   .on("mouseout", () => {
//     tooltip.transition()
//       .duration(500)
//       .style("opacity", 0);
//   });

// // Helper function to generate tooltip text
// function getTooltipText(id) {
//   const tooltipData = {
//     "region-1": "Northern Region (GDP: $1.2B)",
//     "region-2": "Eastern Farmlands",
//     // Add all IDs and their tooltip text
//   };
//   return tooltipData[id] || `Region: ${ id }`; // Fallback text
// }


export default drawMap;
// export default initMapZoom;